import React, { useContext, useEffect } from "react";
import ProductItem from "./ProductItem";
import Loading from "./Loading";
import axios from "axios";
import LoadMore from "./LoadMore";
import MyContext from "../context/MyContext";
import Heros from "./Heros";

const Products = (props) => {
  const context = useContext(MyContext);
  const {
    loading,
    setLoading,
    isCheck,
    setIsCheck,
    callback,
    setCallback,
    products,
    setProducts,
    isAdmin,
    category,
    sort,
    search,
    page,
    setResult
  } = context;

  useEffect(() =>{
    const getProducts = async () => {
        const res = await axios.get(`/products?limit=${page*12}&${category}&${sort}&title[regex]=${search}`)
        setProducts(res.data.products)
        setResult(res.data.result)
    }
    getProducts()
},[callback, category, sort, search, page, setProducts, setResult])

  const handleCheck = (id) => {
    products.forEach((product) => {
      if (product._id === id) product.checked = !product.checked;
    });
    setProducts([...products]);
  };

  const deleteProduct = async (id, public_id) => {
    try {
      setLoading(true);
      const destroyImg = axios.post(
        "/api/destroy",
        { public_id }
      );
      const deleteProduct = axios.delete(`/products/${id}`);
      await destroyImg;
      await deleteProduct;
      setCallback(!callback);
      setLoading(false);
    } catch (err) {
      alert(err.response.data.msg);
    }
  };

  const checkAll = () => {
    products.forEach((product) => {
      product.checked = !isCheck;
    });
    setProducts([...products]);
    setIsCheck(!isCheck);
  };

  const deleteAll = () => {
    products.forEach((product) => {
      if (product.checked) deleteProduct(product._id, product.images.public_id);
    });
  };

  if (loading)
    return (
      <div>
        <Loading />
      </div>
    );
  return (
    <>
      {isAdmin && (
        <div className="delete-all">
          <span>Select all</span>
          <input type="checkbox" checked={isCheck} onChange={checkAll} />
          <button onClick={deleteAll}>Delete ALL</button>
        </div>
      )}

      <Heros data={[{ url: "https://picsum.photos/1200/400" }]} />

      <div className="products">
        {products.map((product) => {
          return (
            <ProductItem
              key={product._id}
              product={product}
              isAdmin={isAdmin}
              deleteProduct={deleteProduct}
              handleCheck={handleCheck}
            />
          );
        })}
      </div>

      <LoadMore />
      {products.length === 0 && <Loading />}
    </>
  );
};

export default Products;
